import React from 'react';
import { isArray } from 'lodash';

import { format, dateFormats } from 'helpers/date';
import { PropTypes } from 'helpers/react';

import {
  green,
  blueGrey,
  blue,
  cyan,
  red,
  yellow,
  grey
} from '@material-ui/core/colors';

import styles from './styles/index.scss';

const { string, number, oneOfType } = PropTypes;

const stateColors = {
  green: green.A700,
  slate: blueGrey[500],
  blue: blue[400],
  yellow: yellow[800],
  cyan: cyan[700],
  red: red[500],
  dark: grey[700],
  paused: yellow[800],
  active: green.A700,
  pending: yellow[800],
  deployed: green.A700
};

export default class LabeledLozenge extends React.Component {
  static propTypes = {
    label: string.isRequired,
    value: oneOfType([string, number]).isRequired,
    color: string,
    format: string
  };

  static defaultProps = {
    color: 'blue'
  };

  format = value => {
    const formats = {
      dateFull: v => format(v, dateFormats.full),
      dateShort: v => format(v, dateFormats.short),
      dateTimeShort: v => {
        const value = format(v, dateFormats.dateTimeShort);
        return value ? value.split(' ') : 'invalid date';
      },
      int: v => Math.round(v)
    };

    const formatter = formats[this.props.format];
    return formatter ? formatter(value) : value;
  };

  render() {
    const formatted = this.format(this.props.value);

    return (
      <div
        className={styles['lozenge']}
        style={{
          border: `1px solid ${stateColors[this.props.color]}`
        }}
      >
        <span
          style={{
            backgroundColor: stateColors[this.props.color]
          }}
        >
          {this.props.label}
        </span>
        <span className={styles['value']}>
          {isArray(formatted)
            ? <span className={styles['wrapper']}>
                <span className={styles['date']}>
                  {formatted[0]}
                </span>
                <span className={styles['time']}>
                  {formatted[1]}
                </span>
              </span>
            : formatted}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/LabeledLozenge/index.js